/**
 * 盘点记录
 */
import React from "react";

import { Modal, Form, Select } from "antd";
import http from "../../../axios/http";

const FormItem = Form.Item;

class BizParkConfigForm extends React.Component {
  state = {
    configData: [],
    config: {
      BizNoRepeatIn: 0,
      BizParkCheckFee: 0,
    },
    changeTime: 0,
  };

  loadConfig() {
    http.post({
      url: "/vehicleStockCheck/configs",
      success: (res) => {
        this.setState({ configData: res });
        var config = this.state.config;
        res.forEach((element) => {
          config[element.ckey] = Number(element.cvalue);
        });
        this.setState({ config });
      },
    });
  }

  componentWillMount() {
    this.loadConfig();
  }

  changeBizParkCheckFee = (num, e) => {
    const { config } = this.state;
    config.BizParkCheckFee = num;
    this.setState({ config });
  };

  changeBizNoRepeatIn = (num, e) => {
    const { config } = this.state;
    config.BizNoRepeatIn = num;
    this.setState({ config });
  };

  changeChangeTime = (num, e) => {
    this.setState({ changeTime: num });
  };

  allCheckDateChange = (date, val) => {
    this.setState({ checkDate: val });
  };

  render() {
    const { visible, onCancel, form } = this.props;
    const { config } = this.state;
    const { getFieldDecorator } = form;
    var formItems = [];
    formItems.push(
      <FormItem label="市场车辆检查重复入场：" key="BizNoRepeatIn">
        {getFieldDecorator("BizNoRepeatIn", {
          initialValue: config.BizNoRepeatIn,
        })(
          <Select disabled={true} onChange={this.changeBizNoRepeatIn}>
            <Select.Option value={0}>关</Select.Option>
            <Select.Option value={1}>开</Select.Option>
          </Select>
        )}
      </FormItem>
    );
    formItems.push(
      <FormItem label="进入市场需结清停车费用：" key="BizParkCheckFee">
        {getFieldDecorator("BizParkCheckFee", {
          initialValue: config.BizParkCheckFee,
        })(
          <Select disabled={true} onChange={this.changeBizParkCheckFee}>
            <Select.Option value={0}>关</Select.Option>
            <Select.Option value={1}>开</Select.Option>
          </Select>
        )}
      </FormItem>
    );
    return (
      <Modal
        visible={visible}
        title="商城停车设置调整"
        okText="确定"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={onCancel}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
        >
          {formItems}
        </Form>
      </Modal>
    );
  }
}
const BizParkConfig = Form.create()(BizParkConfigForm);
export default BizParkConfig;
